import React from "react"

import { ClassHomeTable } from "./classHomeTable.js";
import { ClassHomeSubjects } from "./ClassHomeSubjetcs";
import { ClassHomeWritting } from "./classHomeWriting";
import { LoadingSpinner } from "../../components/Shared";
import { Subjects } from "../../helper"

import "../../App.scss";
import "../../assets/stlyes/ClassHome/ClassHome.scss";

const ClassHomeBody = (props) => {
  const { subjects, pupil, subjectActualAverages, subjectPredictedAverages, assessment, subjectActualOutcomeAverages, subjectPredictedOutcomeAverages, className, assmtAddDisable, year, isNavCollapsed, isLoading } = props;
  return (
    <>
      {isLoading ? <LoadingSpinner /> : <div className={!isNavCollapsed ? "classHomeBody col" : "classHomeBodyFullScreen col"}>
        <ClassHomeTable pupil={pupil} subjectActualAverages={subjectActualAverages} subjectPredictedAverages={subjectPredictedAverages} />
        <div className="classHomeBodySubjects">
          {
            subjects.filter(subject => subject.isChecked === true).map((subject, i) => {
              if (subject.subject === Subjects.Writing) {
                return <ClassHomeWritting key={i} subject={subject} index={i} pupil={pupil} subjectActualAverages={subjectActualAverages} subjectPredictedAverages={subjectPredictedAverages} assessment={assessment} subjectActualOutcomeAverages={subjectActualOutcomeAverages} subjectPredictedOutcomeAverages={subjectPredictedOutcomeAverages} className={className} assmtAddDisable={assmtAddDisable} year={year} isLoading={isLoading} />
              } else {
                return <ClassHomeSubjects key={i} subject={subject} index={i} pupil={pupil} subjectActualAverages={subjectActualAverages} subjectPredictedAverages={subjectPredictedAverages} subjectActualOutcomeAverages={subjectActualOutcomeAverages} subjectPredictedOutcomeAverages={subjectPredictedOutcomeAverages} className={className} isLoading={isLoading} />
              }
            })
          }
        </div>
      </div>}
    </>
  );
}

export { ClassHomeBody };